<template>
  <PDVLaudosPendingPage type="saida" />
</template>

<script setup lang="ts">
import PDVLaudosPendingPage from './PDVLaudosPendingPage.vue';
</script>
